export function getFileExtension(fileName: string) {
	return fileName.substr(fileName.lastIndexOf('.') + 1).toLowerCase();
}
